import { ArrowRight2 } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import PeopleAddColoredIcon from '@/assets/images/icons/people-add-colored-v2.svg?react';
import ProfileAddColoredIcon from '@/assets/images/icons/profile-add-colored-v2.svg?react';
import TagColoredIcon from '@/assets/images/icons/tag-colored-v2.svg?react';
import useFriendRequestCount from '@/hooks/contacts/use-friend-request-count';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function ContactTabs({ className }: Props) {
  const { t } = useTranslation();
  const { friendRequestCount } = useFriendRequestCount();

  return (
    <div className={cn('flex flex-col items-stretch', className)}>
      <Link
        className='flex items-center gap-2 px-5 py-2 h-12'
        to={ROUTES.CONTACT.USERS.APPLICATIONS.$path()}>
        <ProfileAddColoredIcon className='size-5' />

        <span className='text-body text-h2 text-nowrap flex-1'>{t('contact.friends.new-friends')}</span>

        {friendRequestCount > 0 && (
          <span className='bg-red-500 badge badge-sm text-neutral-0 text-[0.625rem] border-neutral-0'>
            {friendRequestCount}
          </span>
        )}

        <ArrowRight2
          className='size-5'
          variant='Linear'
        />
      </Link>

      <Link
        className='flex items-center gap-2 px-5 py-2 h-12'
        to={ROUTES.CONTACT.TAGS.$path()}>
        <TagColoredIcon className='size-5' />

        <span className='text-body text-h2 text-nowrap flex-1'>{t('common.tag')}</span>
        <ArrowRight2
          className='size-5'
          variant='Linear'
        />
      </Link>

      <Link
        className='flex items-center gap-2 px-5 py-2 h-12'
        to={ROUTES.CONTACT.GROUPS.$path()}>
        <PeopleAddColoredIcon className='size-5' />

        <span className='text-body text-h2 text-nowrap flex-1'>{t('contact.groups.title')}</span>
        <ArrowRight2
          className='size-5'
          variant='Linear'
        />
      </Link>
    </div>
  );
}
